module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Chart","commonjs":"chart.js","commonjs2":"chart.js","amd":"chart.js"}
// module id = 3
// module chunks = 0